import React from "react";
import { Link } from "react-router-dom";

import kaisenChirashiDonMenu from "../../assets/images/resource/menu/rice/kaisen-chirashi-don.webp";
import toriCurryDonMenu from "../../assets/images/resource/menu/rice/tori-curry-don.webp";
import katsuCurryDonMenu from "../../assets/images/resource/menu/rice/katsu-curry-don.webp";
import salmonDonMenu from "../../assets/images/resource/menu/rice/salmon-don.webp";

import gyuDonMenu from "../../assets/images/resource/menu/rice/gyu-don.webp";
import butaDonMenu from "../../assets/images/resource/menu/rice/buta-don.webp";
import toriToriDonMenu from "../../assets/images/resource/menu/rice/tori-tori-don.webp";
import shiroGohanMenu from "../../assets/images/resource/menu/rice/shiro-gohan.webp";
import spicyImage from "../../assets/images/resource/spicy.png";

import sakePokeDonMenu from "../../assets/images/resource/menu/rice/sake-poke.webp";

function Rice() {
  return (
    <>
      <section className="menu-two">
        <div className="auto-container">
          <div className="title-box centered">
            <h2>Rice</h2>
          </div>
          <div className="row clearfix">
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={kaisenChirashiDonMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Kaisen Chirashi Don</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$30.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Uni, scallop, salmon, ikura, shiso, ginger & wasabi
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={sakePokeDonMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Sake Poke</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$22.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Salmon, imitation crab, ikura, arugula, tamagoyaki,
                        avocado, pickled onion, tempura flake, nori with
                        homemade yuzu dressing and poke sauce
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={toriCurryDonMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Tori Curry Don</Link>
                          &nbsp;
                          <img
                            src={spicyImage}
                            alt="Icon"
                            width={30}
                            height={30}
                          ></img>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$20.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Marinated fried chicken topped with red ginger, yellow
                        daikon & nori
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={katsuCurryDonMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Katsu Curry Don</Link>
                          &nbsp;
                          <img
                            src={spicyImage}
                            alt="Icon"
                            width={30}
                            height={30}
                          ></img>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$20.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Crispy pork topped with red ginger, yellow daikon & nori
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={salmonDonMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Salmon Don</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$21.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Raw salmon & ikura over rice, shiso tempura with
                        homemade ginger dressing & nori
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={gyuDonMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Gyu Don</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$22.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Marinated beef over rice topped with scallion, yellow
                        daikon & half ajitama
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={butaDonMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Buta Don</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$18.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Roasted pork over rice topped with scallion & mayo
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={toriToriDonMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Tori Tori Don</Link>
                          &nbsp;
                          <img
                            src={spicyImage}
                            alt="Icon"
                            width={30}
                            height={30}
                          ></img>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$18.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Spicy crispy chicken over rice topped with red onion,
                        cilantro & nori
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={shiroGohanMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Shiro Gohan</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$4.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">Japanese white rice</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Rice;
